import { render, staticRenderFns } from "./caibaotab.vue?vue&type=template&id=49a6832e&scoped=true&"
import script from "./caibaotab.vue?vue&type=script&lang=js&"
export * from "./caibaotab.vue?vue&type=script&lang=js&"
import style0 from "./caibaotab.vue?vue&type=style&index=0&id=49a6832e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a6832e",
  null
  
)

export default component.exports